import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledNavLink = styled.span`
  cursor: pointer;

  & a:hover,
  & a:active {
    color: ${(props) => props.theme.colors.second};
  }
`;

const NavTopLink = (props) => {
  let { link, label } = props;
  if (!label) label = link.label;

  return (
    <StyledNavLink>
      <Link to={link}>{label}</Link>
    </StyledNavLink>
  );

};

export default NavTopLink;
